module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mod__flex"
  }, [_c('li', {
    class: 'mod__flex__item '
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "radio",
      "id": _vm.id + 1
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.checked, 1)
    },
    on: {
      "change": function($event) {
        _vm.checked = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio side",
    attrs: {
      "for": _vm.id + 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "140~180H"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    class: 'mod__flex__item '
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "radio",
      "id": _vm.id + 2
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.checked, 2)
    },
    on: {
      "change": function($event) {
        _vm.checked = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio side",
    attrs: {
      "for": _vm.id + 2
    }
  }, [_vm._v("固定")])]), _vm._v(" "), _c('li', {
    class: 'mod__flex__item '
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "radio",
      "id": _vm.id + 3
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.checked, 3)
    },
    on: {
      "change": function($event) {
        _vm.checked = 3
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio side",
    attrs: {
      "for": _vm.id + 3
    }
  }, [_vm._v("時給")])]), _vm._v(" "), _c('li', {
    class: 'mod__flex__item '
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "radio",
      "id": _vm.id + 4
    },
    domProps: {
      "value": 4,
      "checked": _vm._q(_vm.checked, 4)
    },
    on: {
      "change": function($event) {
        _vm.checked = 4
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio side",
    attrs: {
      "for": _vm.id + 4
    }
  }, [_vm._v("不明")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c39396"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/review/form/ContractTime.vue
// module id = 440
// module chunks = 1